module.exports = __webpack_public_path__ + "static/media/bebedouro_industrial_lider.a01980f2.webp";